// A view's name as the reader sees it (spec 16 §3.12 item 10, D-305 ruling
// 11). A system view's name is an i18n key, and only a system name goes
// through `t()`. A member's view carries the words its author typed, which
// are stored data and read the same in every locale, as a colleague's to-do
// does (ruling 29), so they are never looked up: a member who names a view
// `production.list.chips.overdue` sees those words, not "Overdue".

import type { SavedView } from "./view-state";

export function viewLabel(
  view: Pick<SavedView, "name" | "is_system">,
  t: (key: string) => string,
): string {
  return view.is_system ? t(view.name) : view.name;
}
